import React from "react";
import { WaveDivider } from "./Ornaments";

const LINKS = [
  { href: "#about", label: "About", external: false, testId: "footer-about" },
  { href: "#newsletter", label: "Newsletter", external: false, testId: "footer-newsletter" },
  {
    href: "https://www.goodreads.com/author/show/57797883.Chelsea_Ray",
    label: "Goodreads",
    external: true,
    testId: "footer-goodreads",
  },
  {
    href: "https://www.instagram.com/chelsearaywrites",
    label: "Instagram",
    external: true,
    testId: "footer-instagram",
  },
  {
    href: "https://www.tiktok.com/@chelsearaywrites",
    label: "TikTok",
    external: true,
    testId: "footer-tiktok",
  },
  {
    href: "https://www.facebook.com/profile.php?id=61578028846197",
    label: "Facebook",
    external: true,
    testId: "footer-facebook",
  },
  { href: "#contact", label: "Contact", external: false, testId: "footer-contact" },
];

const AUTHOR_EMAIL = "hello@chelsearaywriting.com";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#050a0f] border-t border-[#c9a25a]/15"
      aria-label="Site footer"
    >
      <WaveDivider className="absolute top-0 left-0 right-0 w-full h-10 -translate-y-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          <div>
            <p className="font-accent text-[10px] text-[#c9a25a]">
              The Novel
            </p>
            <h3 className="font-display italic text-3xl text-[#f2e8d5] mt-3">
              Against All Waves
            </h3>
            <p className="mt-3 text-sm text-[#a8b4c0] max-w-xs">
              A young adult pirate fantasy romance by Chelsea Ray.
            </p>
          </div>

          <nav aria-label="Footer" className="md:text-center">
            <p className="font-accent text-[10px] text-[#c9a25a]">Sail To</p>
            <ul className="mt-4 flex flex-col md:items-center gap-3">
              {LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    data-testid={l.testId}
                    href={l.href}
                    {...(l.external
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : {})}
                    className="text-[#a8b4c0] hover:text-[#e8c888] transition-colors duration-300 text-sm"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:text-right">
            <p className="font-accent text-[10px] text-[#c9a25a]">
              By the Author
            </p>
            <p className="mt-4 text-[#a8b4c0] text-sm max-w-xs md:ml-auto">
              Stories of stormy seas, slow-burn romance, and crews who become
              family. Welcome aboard.
            </p>
            <a
              data-testid="footer-email"
              href={`mailto:${AUTHOR_EMAIL}`}
              className="mt-4 inline-block text-sm text-[#c9a25a] hover:text-[#e8c888] transition-colors"
              aria-label={`Email Chelsea Ray at ${AUTHOR_EMAIL}`}
            >
              {AUTHOR_EMAIL}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#c9a25a]/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-xs text-[#a8b4c0]/70">
            © {year} Chelsea Ray. All rights reserved.
          </p>
          <p className="font-accent text-[9px] text-[#c9a25a]/70">
            Against All Waves · YA Pirate Fantasy Romance
          </p>
        </div>
      </div>
    </footer>
  );
}
